import React from "react";
import Lottie from "lottie-react";
import "./NotFound.css";
import { Link } from "react-router-dom";
import animationData from "../../Assets/Error404.json";
import PageMeta from "../../Components/PageMeta";

// Read defensively: this is now the real 404 for the whole site, reached by
// anyone who mistypes a URL, and a malformed "user" in localStorage used to
// throw here — turning a not-found page into a blank screen.
const storedUser = () => {
  try { return JSON.parse(localStorage.getItem("user") || "null"); }
  catch { return null; }
};

const NotFound = () => {
  const user = storedUser();
  const isUser = user?.role === "user";
  // A signed-out visitor is a visitor, not an administrator. This page used
  // to offer everyone who was not a company user "العودة إلى لوحة تحكم
  // الإدارة" — so someone who mistyped a shop's address was pointed at the
  // platform's super-admin dashboard.
  const home = isUser
    ? { to: "/company", label: "العودة إلى لوحة التحكم" }
    : (user ? { to: "/admin/dashboard", label: "العودة إلى لوحة تحكم الإدارة" }
            : { to: "/", label: "العودة إلى الصفحة الرئيسية" });

  return (
    <div className="notfound-wrapper">
      <PageMeta
        title="الصفحة غير موجودة"
        description="لم نتمكن من العثور على الصفحة المطلوبة."
        noIndex
        follow
      />
      <div className="notfound-card">
        <div className="lottie-box">
          <Lottie animationData={animationData} loop />
        </div>
        <h1>الصفحة غير موجودة</h1>
        <p>الصفحة التي تبحث عنها غير موجودة أو تم نقلها.</p>

        <Link to={home.to} className="go-home-btn">
          ⟵ {home.label}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
